import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  ModalWindowComponent,
  ModalWindowData,
} from '@macs-frontend/web-macs/shared/components/modal-window/modal-window.component';
import { EMPTY, Observable, ObservedValueOf, OperatorFunction } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ErrorHelperService {
  constructor(private dialog: MatDialog) {}

  public catchRequestError<T>(): OperatorFunction<
    T,
    ObservedValueOf<Observable<never>> | T
  > {
    return catchError(error => {
      this.dialog.open(ModalWindowComponent, {
        data: {
          contentList: [],
          title: 'Heads up!',
          description: error.error.details,
        } as ModalWindowData,
      });

      return EMPTY;
    });
  }
}
